import React from "react";
import { AHIcon, AHText, TouchableBox } from "arkh";
import { FormattedMessage } from "react-intl";

function TaskOccasionItemCMP(props: {
  status: "REQUIRED" | "OPTIONAL" | null;
  onPress: () => void;
}) {
  return (
    <TouchableBox
      color="surface"
      cornerRadius="small"
      space="small"
      style={{ alignItems: "center", justifyContent: "center", flex: 1 }}
      onPress={props.onPress}
    >
      {props.status === "REQUIRED" ? (
        <AHIcon type="check" color="washedText" size="medium" />
      ) : null}
      {props.status === "OPTIONAL" ? (
        <AHText type="detail" color="washedText">
          <FormattedMessage
            defaultMessage="Optional"
            description="Routine Schedule TaskOccasionItem optional icon"
          />
        </AHText>
      ) : null}
      {props.status === null ? (
        <AHText type="title-small" color="washedText">
          -
        </AHText>
      ) : null}
    </TouchableBox>
  );
}

export const TaskOccasionItem = React.memo(TaskOccasionItemCMP);
